import { render } from "./ContactComp.vue?vue&type=template&id=5f6409d3"
import script from "./ContactComp.vue?vue&type=script&lang=js"
export * from "./ContactComp.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/new-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__